var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboundLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 2,
    viewBox: "0 0 25 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.774414,
    y1: 1.25,
    x2: 24.3612,
    y2: 1.25,
    stroke: "#FF0A7A",
    strokeWidth: 1.5,
    strokeDasharray: "1.97 1.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboundLine);
export default __webpack_public_path__ + "static/media/inbound-line.b80b7e5dbf8498bb1fb5b1342f5b6dee.svg";
export { ForwardRef as ReactComponent };